import api from './api';

const ENDPOINT = 'redemptions';

const RedemptionService = {
  trade: (points) => api.post(`${ENDPOINT}/trade`, { points }),
  tradeCard: (points, noCard = false) =>
    api.post(`${ENDPOINT}/trade-card`, { points, no_card: noCard }),
};

export default RedemptionService;
